const {
  SOURCE_UA_2020_03_26_SPELLS_AND_MAGIC_TATTOOS,
} = require('./../../../../sourceList')
const {
  ARMOR_TYPE_NATURAL,
} = require('./../../../../armorTypeList')
const {
  SIZE_SMALL,
} = require('./../../../../sizeList')
const {
  CREATURE_TYPE_FEY,
} = require('./../../../../creatureTypeIdList')
const {
  LANG_ITS_CREATOR,
  LANG_SYLVAN,
} = require('./../../../../languageIdList')
const {
  ALIGNMENT_CG,
} = require('./../../../../aligmentList')
const {
  SPEED_WALK,
} = require('./../../../../speedList')
const {
  ATTACK_MELEE_WEAPON,
} = require('./../../../../attackTypeList')
const {
  DAMAGE_FORCE,
  DAMAGE_PIERCING,
} = require('./../../../../damageTypeList')
const {
  CONDITION_CHARMED,
} = require('./../../../../conditionList')
const {
  SENSE_DARK_VISION,
} = require('./../../../../senseList')
const {
  PARAM_STR,
  PARAM_DEX,
  PARAM_CON,
  PARAM_INT,
  PARAM_WIT,
  PARAM_CHA,
} = require('./../../../../paramList')
const {
  GENDER_MALE,
} = require('./../../../../genderList')
const {
  CREATURE_DECEITFUL_FEY_SPIRIT_2020_03_26,
  CREATURE_TRICKSY_SPIRIT,
} = require('./../../../../creatureIdList')
const {
  GEAR_SHORTSWORD,
} = require('./../../../../gearIdList')
const {
  SPELL_SUMMON_FEY_SPIRIT_2020_03_26,
} = require('./../../../../spellIdList')

module.exports = {
  name: 'Дух лживой феи',
  nameEn: 'Deceitful Fey Spirit',
  id: CREATURE_DECEITFUL_FEY_SPIRIT_2020_03_26,
  releasedAs: CREATURE_TRICKSY_SPIRIT,
  createdBySpellId: SPELL_SUMMON_FEY_SPIRIT_2020_03_26,
  sizeType: SIZE_SMALL,
  creatureTypeIdList: [
    CREATURE_TYPE_FEY,
  ],
  alignmentId: ALIGNMENT_CG,
  source: {
    id: SOURCE_UA_2020_03_26_SPELLS_AND_MAGIC_TATTOOS,
    page: 5,
  },
  armor: {
    ac: 11,
    type: ARMOR_TYPE_NATURAL,
    comment: `+ круг заклинания`,
  },
  hp: `модификатор Телосложения духа + модификатор заклинательной характеристики заклинателя + десятикратный круг заклинания`,
  speed: {
    [SPEED_WALK]: 40,
  },
  params: {
    [PARAM_STR]: 13,
    [PARAM_DEX]: 16,
    [PARAM_CON]: 14,
    [PARAM_INT]: 14,
    [PARAM_WIT]: 11,
    [PARAM_CHA]: 16,
  },
  immunityConditionList: [
    CONDITION_CHARMED,
  ],
  senseList: [
    {
      id: SENSE_DARK_VISION,
      value: 60,
    },
  ],
  languageList: [
    LANG_SYLVAN,
    {
      id: LANG_ITS_CREATOR,
      doNotSpeak: true,
    },
  ],
  featureList: [
    {
      name: 'Фейский шаг',
      description: `Бонусным действием ★СУЩЕСТВО★ может магически телепортироваться в свободное пространство, видимое им в пределах 30 футов.`,
    },
    {
      name: 'Тёмный шаг',
      description: `Немедленно после использования _Фейского шага_, ★СУЩЕСТВО★ может заполнить куб со стороной 5 футов в пределах 5 футов от себя магической темнотой, которая останется там до конца его следующего хода.`,
    },
  ],
  actionList: [
    {
      name: 'Мультиатака',
      description: `★СУЩЕСТВО★ совершает число атак, равное половине круга заклинания`,
    },
    {
      name: 'Короткий меч',
      // gearId: GEAR_SHORTSWORD, // TODO: Найти способ перетащить в оружие с комментариями
      attack: {
        type: ATTACK_MELEE_WEAPON,
        bonus: {
          value: 3,
          comment: `+ круг заклинания`,
        },
        range: 5,
        hit: [
          {
            type: DAMAGE_PIERCING,
            diceCount: 1,
            diceType: 6,
            diceBonus: 3,
            comment: ` + круг заклинания`,
          },
          {
            type: DAMAGE_FORCE,
            diceCount: 1,
            diceType: 6,
          },
        ],
      },
    },
  ],
  genderId: GENDER_MALE,
}
